(function () {
  function productString(key) {
    return ((window.Axiom && window.Axiom.productStrings && window.Axiom.productStrings[key]) || '').toString();
  }

  function setMotionButtonText(target, text) {
    if (!target) return;
    if (window.Axiom && typeof window.Axiom.setMotionLabel === 'function') {
      if (window.Axiom.setMotionLabel(target, text, 'button')) return;
    }
    target.textContent = text;
  }

  function cartString(key) {
    return ((window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings[key]) || '').toString();
  }

  function sellingPlanIdFromForm(form) {
    var input = form && (form.querySelector('[data-selling-plan-input]') || form.querySelector('[name="selling_plan"]'));
    return input ? String(input.value || '').trim() : '';
  }

  function initAxiomProduct(root) {
    var scope = root && root.querySelector ? root : document;
    var sectionEl = scope && scope.matches && scope.matches('[data-product-root]')
      ? scope
      : scope.querySelector('[data-product-root]');
    if (!sectionEl) return;
    var sectionScope = sectionEl.closest('[id^="shopify-section-"]') || sectionEl;
    if (sectionEl.dataset && sectionEl.dataset.productInitialized === 'true') return;
    if (sectionEl.dataset) sectionEl.dataset.productInitialized = 'true';
    var cleanups = [];
    var atcFeedbackTimer = null;
    var stickyObs = null;
    var stickyResizeObserver = null;

    function on(target, eventName, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      target.addEventListener(eventName, handler, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function queryInRoot(selector) {
      return sectionEl.querySelector(selector);
    }

    function queryAllInRoot(selector) {
      return Array.prototype.slice.call(sectionEl.querySelectorAll(selector));
    }

    function queryInSection(selector) {
      return sectionScope.querySelector(selector);
    }

    function queryAllInSection(selector) {
      return Array.prototype.slice.call(sectionScope.querySelectorAll(selector));
    }

    function queryById(scopeNode, id) {
      if (!scopeNode) return null;
      return scopeNode.querySelector('#' + id);
    }

    function portalStickyAtc(stickyAtc) {
      if (!stickyAtc || stickyAtc.parentNode === document.body) return;
      // Footer reveal transforms #main-content; fixed children there become section-bound.
      document.body.appendChild(stickyAtc);
    }


    function getFormSubmitter(event) {
      if (event && event.submitter) return event.submitter;
      return document.activeElement && document.activeElement.closest
        ? document.activeElement.closest('button, input[type="submit"]')
        : null;
    }

  // ── PRODUCT DATA ──────────────────────────────
  var productJsonEl = queryInSection('[id^="product-json-"]');
  var productData = null;
  try { if (productJsonEl) productData = JSON.parse(productJsonEl.textContent); } catch(e) {}
  var productConfigEl = queryInSection('[data-product-config]');
  var productSectionConfig = {};
  try { if (productConfigEl) productSectionConfig = JSON.parse(productConfigEl.textContent); } catch(e) {}
  productSectionConfig = decodeConfigStrings(productSectionConfig);
  var productB2BConfigEl = queryInSection('[data-product-b2b-config]');
  var productB2BConfig = {};
  try { if (productB2BConfigEl) productB2BConfig = JSON.parse(productB2BConfigEl.textContent); } catch(e) {}
  var highVariantState = window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.read(sectionScope);
  var highVariantProduct = window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.isHighVariant(highVariantState);
  var selectedHighVariant = highVariantProduct ? highVariantState.variant : null;
  var highVariantRequest = null;
  if (highVariantProduct && selectedHighVariant && highVariantState.variantState) {
    productB2BConfig.variants = productB2BConfig.variants || {};
    productB2BConfig.variants[String(selectedHighVariant.id)] = highVariantState.variantState;
    if (productB2BConfigEl) productB2BConfigEl.textContent = JSON.stringify(productB2BConfig);
  }

  function decodeHtmlString(value) {
    if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function decodeConfigStrings(config) {
    Object.keys(config || {}).forEach(function (key) {
      config[key] = decodeHtmlString(config[key]);
    });
    return config || {};
  }

  function money(cents) {
    return window.Axiom.formatMoney(cents);
  }

  // ── MEDIA GALLERY ─────────────────────────────
  var mainWrap = queryById(sectionEl, 'mainImageWrap');
  var mediaGallery = queryInRoot('[data-media-gallery]');
  var mediaStage = queryInRoot('[data-media-stage]');
  var mediaItemEls = queryAllInRoot('[data-media-item]');
  var thumbBtns = queryAllInRoot('[data-thumb]');
  var prevThumbNavBtn = queryInRoot('[data-thumb-nav-prev]');
  var nextThumbNavBtn = queryInRoot('[data-thumb-nav-next]');
  var prevMediaBtn = queryInRoot('[data-media-prev]');
  var nextMediaBtn = queryInRoot('[data-media-next]');
  var splitShowcaseRows = queryAllInRoot('[data-split-showcase-row]');
  var splitRowPrevBtns = queryAllInRoot('[data-split-row-prev]');
  var splitRowNextBtns = queryAllInRoot('[data-split-row-next]');
  var isOneImageStack = !!(mediaGallery && mediaGallery.classList.contains('media-gallery--stacked_full_image'));
  var isVerticalSplitImage = !!(mediaGallery && mediaGallery.classList.contains('media-gallery--vertical_split_image'));
  var mediaItems = [];
  var currentIdx = Math.max(0, Array.prototype.findIndex.call(mediaItemEls, function (item) {
    return item.classList.contains('active');
  }));
  if (currentIdx < 0) currentIdx = 0;
  mediaItemEls.forEach(function (itemEl, index) {
    var mediaEl = itemEl.querySelector('.media-main');
    mediaItems.push({
      id: itemEl.dataset.mediaId || '',
      type: itemEl.dataset.mediaType || 'image',
      lightbox: itemEl.dataset.lightboxSrc || '',
      mediaEl: mediaEl
    });
    if (itemEl.classList.contains('active')) currentIdx = index;
  });

  // A single gallery controller owns active media, thumbnail state and page-scroll
  // synchronization for both stacked and vertical galleries. The callbacks keep
  // PDP-specific XR/media behavior outside of the shared controller.
  var galleryController = window.AxiomProductGalleryController && mediaGallery
    ? window.AxiomProductGalleryController.create(mediaGallery, {
        mediaSelector: '[data-media-item]',
        thumbSelector: '[data-thumb]',
        pauseMedia: function () { pauseProductMedia(mediaGallery); },
        isControlTarget: function (target) {
          return window.AxiomProductMedia && window.AxiomProductMedia.isControlTarget
            ? window.AxiomProductMedia.isControlTarget(target)
            : false;
        },
        onActiveChange: function (item, index) {
          currentIdx = index;
          if (mainWrap && item) mainWrap.dataset.currentMediaType = item.type;
          if (mediaGallery && window.AxiomProductMedia) {
            window.AxiomProductMedia.syncXrButton(mediaGallery, item && item.id);
            window.AxiomProductMedia.playAutoplay(item && item.element);
          }
        }
      })
    : null;
  if (galleryController) {
    mediaItems = galleryController.items;
    mediaItemEls = galleryController.mediaItems;
    thumbBtns = galleryController.allThumbBtns;
    currentIdx = galleryController.currentIdx;
  }

  // ── FIT TO SCREEN ─────────────────────────────
  // Media block > Fit media to the screen: see product-media-viewer.js.
  if (mediaGallery && mediaGallery.dataset.fitScreen === 'true' && window.AxiomProductMediaViewer) {
    var fitScreen = window.AxiomProductMediaViewer.fitScreen(mediaGallery, { surface: 'page', layoutRoot: sectionEl });
    cleanups.push(fitScreen.dispose);
  }

  // ── STICKY DETAILS ────────────────────────────
  // Beside a tall gallery the details stick under the header (product.css,
  // component-product-detail-containers.css). Details taller than the screen
  // would keep their end out of reach until the gallery ends, so they stick
  // at the room the screen leaves under them instead: they scroll with the
  // page until their end shows, then stay. Details that fit keep the CSS top.
  var stickyDetailEls = queryAllInRoot('.product-form, .product-detail-container');
  if (stickyDetailEls.length) {
    var stickyDetailsFrame = null;
    var syncStickyDetailsTop = function () {
      stickyDetailsFrame = null;
      var header = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--axiom-header-height'));
      var headerTop = (Number.isFinite(header) ? header : 68) + 16;
      stickyDetailEls.forEach(function (element) {
        var room = window.innerHeight - element.offsetHeight - 16;
        var sticky = window.getComputedStyle(element).position === 'sticky';
        if (sticky && room < headerTop) {
          element.style.setProperty('--product-details-sticky-top', Math.round(room) + 'px');
        } else {
          element.style.removeProperty('--product-details-sticky-top');
        }
      });
    };
    var scheduleStickyDetailsTop = function () {
      if (!stickyDetailsFrame) stickyDetailsFrame = window.requestAnimationFrame(syncStickyDetailsTop);
    };
    on(window, 'resize', scheduleStickyDetailsTop, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var stickyDetailsObserver = new ResizeObserver(scheduleStickyDetailsTop);
      stickyDetailEls.forEach(function (element) { stickyDetailsObserver.observe(element); });
      cleanups.push(function () { stickyDetailsObserver.disconnect(); });
    }
    cleanups.push(function () {
      if (stickyDetailsFrame) window.cancelAnimationFrame(stickyDetailsFrame);
    });
    syncStickyDetailsTop();
  }

  function pauseProductMedia() {
    if (window.AxiomProductMedia) {
      window.AxiomProductMedia.pauseAll(mediaGallery || document);
    }
  }

  function setMedia(idx, options) {
    if (!mediaItems.length) return;
    options = options || {};
    if (!galleryController) return;
    var result = galleryController.setMedia(idx, options);
    if (result) currentIdx = result.index;
  }

  function setMediaById(mediaId, options) {
    if (!mediaId) return;
    options = options || {};
    var id = String(mediaId);
    var idx = mediaItems.findIndex(function (item) { return String(item.id) === id; });
    if (idx >= 0) {
      setMedia(idx, {
        scrollMedia: options.scrollMedia === true,
        scrollThumb: options.scrollThumb === true
      });
    }
  }



  function getSplitRowStep(track) {
    if (!track) return 0;
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-media-item]'));
    if (items.length > 1) {
      return Math.max(items[1].offsetLeft - items[0].offsetLeft, items[0].getBoundingClientRect().width || 0);
    }
    return items[0] ? items[0].getBoundingClientRect().width || 0 : track.clientWidth;
  }

  function updateSplitRowNav(row) {
    if (!row) return;
    var track = row.querySelector('[data-split-showcase-track]');
    var prev = row.querySelector('[data-split-row-prev]');
    var next = row.querySelector('[data-split-row-next]');
    if (!track || (!prev && !next)) return;
    var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= maxScroll - 1;
    var isScrollable = maxScroll > 1;
    if (prev) {
      prev.classList.toggle('is-disabled', !isScrollable || atStart);
      prev.setAttribute('aria-disabled', String(!isScrollable || atStart));
    }
    if (next) {
      next.classList.toggle('is-disabled', !isScrollable || atEnd);
      next.setAttribute('aria-disabled', String(!isScrollable || atEnd));
    }
  }

  function updateSplitShowcaseNav() {
    splitShowcaseRows.forEach(updateSplitRowNav);
  }

  function scrollSplitShowcaseRow(button, direction) {
    var row = button.closest('[data-split-showcase-row]');
    var track = row ? row.querySelector('[data-split-showcase-track]') : null;
    if (!track) return;
    var step = getSplitRowStep(track);
    track.scrollBy({
      left: step * direction,
      behavior: 'smooth'
    });
    window.setTimeout(function () {
      updateSplitRowNav(row);
    }, 260);
  }

  if (prevMediaBtn) {
    prevMediaBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx - 1, { scrollMedia: true });
    });
  }
  if (nextMediaBtn) {
    nextMediaBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx + 1, { scrollMedia: true });
    });
  }
  if (prevThumbNavBtn) {
    prevThumbNavBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx - 1, { scrollMedia: true });
    });
  }
  if (nextThumbNavBtn) {
    nextThumbNavBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx + 1, { scrollMedia: true });
    });
  }
  splitRowPrevBtns.forEach(function (button) {
    on(button, 'click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollSplitShowcaseRow(button, -1);
    });
  });
  splitRowNextBtns.forEach(function (button) {
    on(button, 'click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollSplitShowcaseRow(button, 1);
    });
  });
  splitShowcaseRows.forEach(function (row) {
    var track = row.querySelector('[data-split-showcase-track]');
    if (track) on(track, 'scroll', function () { updateSplitRowNav(row); }, { passive: true });
  });
  if (splitShowcaseRows.length) {
    on(window, 'resize', updateSplitShowcaseNav);
    updateSplitShowcaseNav();
  }
  if (mediaItems.length) {
    setMedia(currentIdx, { scrollMedia: false });
    if ((isVerticalSplitImage || isOneImageStack) && galleryController) galleryController.syncFromScroll();
    updateSplitShowcaseNav();
  }

  // ── LIGHTBOX ──────────────────────────────────
  // See product-media-viewer.js; the lightbox moves to the end of the page.
  var lightboxEl = queryById(sectionScope, 'lightbox');
  if (mediaGallery && lightboxEl && window.AxiomProductMediaViewer) {
    var mediaLightbox = window.AxiomProductMediaViewer.lightbox(mediaGallery, {
      lightbox: lightboxEl,
      getItems: function () { return mediaItems; },
      getIndex: function () { return currentIdx; },
      setMedia: setMedia,
      removeOnDispose: true
    });
    if (mediaLightbox) cleanups.push(mediaLightbox.dispose);
  }

  // ── VARIANT PICKER ────────────────────────────
  var variantIdInput = queryInRoot('[data-variant-id]');
  var productCartStatus = queryInRoot('[data-product-cart-status]');
  var currentOptions = {};

  function getVariantB2BData(variantId) {
    if (!productB2BConfig || !productB2BConfig.variants || !variantId) return null;
    return productB2BConfig.variants[String(variantId)] || null;
  }

  function getVariantQuantityRule(variant) {
    return window.AxiomVariantForm.getQuantityRule(variant, productB2BConfig);
  }

  function shouldCheckVariantInventory(variant) {
    return window.AxiomVariantForm.shouldCheckInventory(variant, productB2BConfig);
  }

  function getVariantInventoryQuantity(variant) {
    return window.AxiomVariantForm.getInventoryQuantity(variant, productB2BConfig);
  }

  function getVariantCartQuantity(variant) {
    var variantState = variant && getVariantB2BData(variant.id);
    return Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
  }

  function isQuantityRuleSoldOut(variant) {
    if (window.AxiomVariantForm.isSoldOut(variant, productB2BConfig)) return true;
    return shouldCheckVariantInventory(variant)
      && getVariantInventoryQuantity(variant) < getVariantQuantityRule(variant).min;
  }

  function getEffectiveMaxQty(variant) {
    return window.AxiomVariantForm.getEffectiveMaxQty(variant, productB2BConfig);
  }

  function isCartQuantityLimitReached(variant) {
    if (!variant || isQuantityRuleSoldOut(variant)) return false;
    var max = getEffectiveMaxQty(variant);
    if (max === null) return false;
    var quantityRule = getVariantQuantityRule(variant);
    var minimumAddQuantity = getVariantCartQuantity(variant) >= quantityRule.min
      ? quantityRule.increment
      : quantityRule.min;
    return max < minimumAddQuantity;
  }

  function getProductQuantityBounds(variant) {
    var quantityRule = getVariantQuantityRule(variant);
    var max = getEffectiveMaxQty(variant);
    var min = getVariantCartQuantity(variant) >= quantityRule.min
      ? quantityRule.increment
      : quantityRule.min;
    return { min: min, max: max, increment: quantityRule.increment };
  }

  function normalizeMainQty(rawValue, variant, allowZero) {
    if (!variant || isQuantityRuleSoldOut(variant)) return 0;
    var bounds = getProductQuantityBounds(variant);
    var value = parseInt(rawValue, 10);
    if (!Number.isFinite(value)) value = allowZero ? 0 : bounds.min;
    if (allowZero && value <= 0) return 0;
    if (value < bounds.min) value = bounds.min;
    if (value > bounds.min) value -= (value - bounds.min) % bounds.increment;
    if (bounds.max !== null && value > bounds.max) {
      value = bounds.max;
      if (value >= bounds.min) value -= (value - bounds.min) % bounds.increment;
    }
    return Math.max(allowZero ? 0 : bounds.min, value);
  }

  function getDisplayPricing(variant, purchaseOptionState) {
    var allocation = purchaseOptionState && purchaseOptionState.allocation ? purchaseOptionState.allocation : null;
    return {
      price: allocation && allocation.price != null ? allocation.price : variant.price,
      compareAtPrice: allocation && allocation.compareAtPrice != null ? allocation.compareAtPrice : variant.compare_at_price
    };
  }

  function getAtcActiveLabel(button) {
    return button.dataset.addLabel || productString('addToCart');
  }

  var dynamicCheckoutRoot = queryInRoot('[data-dynamic-checkout]');

  function setVariantLoading(isLoading) {
    var button = queryInRoot('[data-atc-btn]');
    if (button) button.classList.toggle('is-variant-loading', Boolean(isLoading));
    if (dynamicCheckoutRoot) dynamicCheckoutRoot.classList.toggle('is-variant-loading', Boolean(isLoading));
  }

  function setDynamicCheckoutLoading(isLoading) {
    if (!dynamicCheckoutRoot) return;
    dynamicCheckoutRoot.classList.toggle('is-loading', Boolean(isLoading));
  }

  function isDynamicCheckoutActivation(event) {
    var path = event && typeof event.composedPath === 'function'
      ? event.composedPath()
      : [event && event.target];

    return path.some(function (node) {
      return node && node.nodeType === 1 && node.matches && node.matches(
        'shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button__button'
      );
    });
  }

  function updateInventoryStatusUI(variant, soldOutByRule) {
    var inventoryStatus = queryInRoot('[data-inventory-status]');
    if (!inventoryStatus || !variant) return;
    var inventoryQty = Math.max(0, getVariantInventoryQuantity(variant));
    var threshold = Math.max(1, parseInt(inventoryStatus.dataset.lowStockThreshold, 10) || 15);
    var showLowStock = productSectionConfig.manualPreorder !== true
      && variant.available
      && !soldOutByRule
      && shouldCheckVariantInventory(variant)
      && inventoryQty > 0
      && inventoryQty <= threshold;
    inventoryStatus.hidden = !showLowStock;
    if (showLowStock) {
      if (window.AxiomInventoryMessage) window.AxiomInventoryMessage.update(inventoryStatus, inventoryQty);
    }
  }

  function updateDynamicCheckoutUI(variant, soldOutByRule, purchaseOptionState, cartLimitReached) {
    if (!dynamicCheckoutRoot || !variant) return;
    var isDisabled = !variant.available || soldOutByRule || cartLimitReached;
    dynamicCheckoutRoot.classList.toggle('dynamic-checkout--disabled', isDisabled);
    dynamicCheckoutRoot.classList.toggle('is-loading', false);
    dynamicCheckoutRoot.dataset.soldOut = isDisabled ? 'true' : 'false';
  }

  function syncProductPurchaseControls(variant, soldOutByRule, purchaseOptionState) {
    var atcButton = queryInRoot('[data-atc-btn]');
    var atcLabel = atcButton ? atcButton.querySelector('.atc-label') : null;
    var stickyRoot = document.getElementById('stickyAtc') || queryById(sectionScope, 'stickyAtc');
    var stickyButton = stickyRoot ? stickyRoot.querySelector('[data-sticky-atc]') : null;
    var stickyLabel = stickyButton ? stickyButton.querySelector('.sticky-btn__label') : null;
    var cartLimitReached = isCartQuantityLimitReached(variant);
    var isPurchasable = variant.available && !soldOutByRule && !cartLimitReached;

    if (atcButton) {
      atcButton.disabled = !isPurchasable;
      if (atcLabel) {
        setMotionButtonText(atcLabel, variant.available && !soldOutByRule
          ? getAtcActiveLabel(atcButton)
          : (atcButton.dataset.soldOutLabel || productString('soldOut')));
      }
    }
    if (stickyButton) {
      stickyButton.disabled = !isPurchasable;
      stickyButton.classList.toggle('is-disabled', !isPurchasable);
      stickyButton.setAttribute('aria-disabled', String(!isPurchasable));
      if (stickyLabel) {
        setMotionButtonText(stickyLabel, variant.available && !soldOutByRule
          ? getAtcActiveLabel(stickyButton)
          : (stickyButton.dataset.soldOutLabel || productString('soldOut')));
      }
    }

    updateDynamicCheckoutUI(variant, soldOutByRule, purchaseOptionState, cartLimitReached);
    updateNotifyUI(variant);
  }

  function updateNotifyUI(variant) {
    var notify = queryInRoot('[data-product-notify]');
    if (!notify || !variant) return;
    notify.hidden = !!variant.available && !notify.classList.contains('is-done');
    var body = notify.querySelector('[data-product-notify-body]');
    if (body) body.value = body.value.replace(/\([^()]*\)$/, '(' + variant.title + ')');
  }

  // After a request the page reloads with the contact form marked as posted: show the thanks.
  (function showNotifyThanks() {
    var notify = queryInRoot('[data-product-notify]');
    if (!notify || !document.querySelector('[data-product-notify-posted]')) return;
    notify.classList.add('is-done');
    notify.hidden = false;
    var row = notify.querySelector('[data-product-notify-row]');
    var heading = notify.querySelector('[data-product-notify-heading]');
    var done = notify.querySelector('[data-product-notify-done]');
    if (row) row.hidden = true;
    if (heading) heading.hidden = true;
    if (done) done.hidden = false;
  })();

  function dispatchQuantityChange(variant, quantity) {
    document.dispatchEvent(new CustomEvent('product:quantity:change', {
      detail: {
        productId: productData && productData.id,
        variantId: variant && variant.id,
        quantity: parseInt(quantity, 10) || 0
      }
    }));
  }

  function getSelectedVariant() {
    if (highVariantProduct) return selectedHighVariant;
    return window.AxiomVariantForm.findVariant(productData, currentOptions);
  }

  function syncSelectedOptionsUI(variant) {
    var options = window.AxiomVariantForm.getVariantOptions(variant);
    if (!options.length) return;
    options.forEach(function (value, index) {
      var position = index + 1;
      currentOptions[position] = value;
      queryAllInRoot('[data-option-position="' + position + '"]').forEach(function (item) {
        var isActive = item.dataset.value === value;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      queryAllInRoot('[data-option-selected-value="' + position + '"]').forEach(function (label) {
        label.textContent = value;
      });
    });
  }

  function syncOptionAvailabilityUI() {
    if (highVariantProduct) {
      window.AxiomHighVariantPicker.applyAvailability(sectionEl, '[data-option-position]', highVariantState);
      return;
    }
    queryAllInRoot('[data-option-position]').forEach(function (button) {
      var position = parseInt(button.dataset.optionPosition, 10);
      var candidateVariant = window.AxiomVariantForm.findAvailableVariantForOptionValue(
        productData,
        currentOptions,
        position,
        button.dataset.value,
        productB2BConfig
      );
      var isUnavailable = !candidateVariant;
      button.classList.toggle('unavailable', isUnavailable);
      button.dataset.resolvedOptionVariantId = candidateVariant ? String(candidateVariant.id) : '';
      button.dataset.optionValueAvailable = isUnavailable ? 'false' : 'true';
      button.removeAttribute('aria-disabled');
      var unavailableLabel = button.querySelector('[data-option-unavailable-label]');
      if (unavailableLabel) unavailableLabel.hidden = !isUnavailable;
      if (button.dataset.optionAccessibleLabel) {
        button.setAttribute('aria-label', button.dataset.optionAccessibleLabel + (isUnavailable && unavailableLabel ? unavailableLabel.textContent : ''));
      }
    });
  }

  function syncVariantImageSwatchesUI() {
    if (!window.AxiomVariantForm || typeof window.AxiomVariantForm.syncVariantImageSwatches !== 'function') return;
    window.AxiomVariantForm.syncVariantImageSwatches({
      root: sectionEl,
      buttonSelector: '[data-option-position]',
      product: productData,
      selected: window.AxiomVariantForm.selectedOptions(sectionEl, '[data-option-position]'),
      contextualState: highVariantProduct ? highVariantState : null
    });
  }

  function formatSaveLabel(compare, price, template, mode) {
    var savings = compare - price;
    var replacement = money(savings);
    if (mode === 'percent' && compare > 0) {
      replacement = String(Math.round((savings * 100) / compare)) + '%';
    }
    return String(template || productString('saving'))
      .replace('[amount]', replacement)
      .replace('[percent]', replacement);
  }

  function setUnavailableSelectionUI() {
    setVariantLoading(false);
    var unavailableLabel = productString('unavailable');
    var priceEl = queryInRoot('[data-price]');
    var priceBlock = queryInRoot('[data-price-block]');
    var compareEl = queryInRoot('[data-compare-price]');
    var saveEl = queryInRoot('[data-save-badge]');
    var unitPriceEl = queryInRoot('[data-unit-price]');
    var atcButton = queryInRoot('[data-atc-btn]');
    var atcLabel = atcButton ? atcButton.querySelector('.atc-label') : null;
    var inventoryStatus = queryInRoot('[data-inventory-status]');
    var skuEl = queryInRoot('[data-sku]');
    var stickyRoot = document.getElementById('stickyAtc') || queryById(sectionScope, 'stickyAtc');
    var stickyPrice = stickyRoot ? stickyRoot.querySelector('[data-sticky-price]') : null;
    var stickyVariant = stickyRoot ? stickyRoot.querySelector('#stickyVariant') : null;
    var stickyButton = stickyRoot ? stickyRoot.querySelector('[data-sticky-atc]') : null;
    var stickyLabel = stickyButton ? stickyButton.querySelector('.sticky-btn__label') : null;

    if (variantIdInput) variantIdInput.value = '';

    if (priceEl) {
      priceEl.textContent = unavailableLabel;
      priceEl.removeAttribute('aria-label');
      priceEl.classList.add('price-current--unavailable');
    }
    if (priceBlock) priceBlock.removeAttribute('data-on-sale');
    if (compareEl) {
      compareEl.hidden = true;
      compareEl.style.display = 'none';
    }
    if (saveEl) {
      saveEl.hidden = true;
      saveEl.style.display = 'none';
    }
    if (unitPriceEl) {
      unitPriceEl.textContent = '';
      unitPriceEl.removeAttribute('aria-label');
      unitPriceEl.hidden = true;
    }
    if (skuEl) skuEl.textContent = '';

    if (atcButton) {
      atcButton.disabled = true;
      atcButton.classList.remove('loading', 'added');
    }
    setMotionButtonText(atcLabel, unavailableLabel);
    if (stickyButton) {
      stickyButton.disabled = true;
      stickyButton.classList.add('is-disabled');
      stickyButton.setAttribute('aria-disabled', 'true');
    }
    setMotionButtonText(stickyLabel, unavailableLabel);
    if (stickyPrice) stickyPrice.textContent = '';
    if (stickyVariant) stickyVariant.textContent = '';

    if (qtyInput) qtyInput.value = '0';
    if (qtyVal) qtyVal.textContent = '0';
    if (qtyMinusBtn) qtyMinusBtn.disabled = true;
    if (qtyPlusBtn) qtyPlusBtn.disabled = true;
    dispatchQuantityChange(null, 0);

    if (inventoryStatus) {
      // The inventory block is a low-stock notice, not the variant availability owner.
      // Preserve its Liquid/RTE markup so a later valid variant can update {count}.
      inventoryStatus.hidden = true;
    }
    if (dynamicCheckoutRoot) {
      dynamicCheckoutRoot.classList.add('dynamic-checkout--disabled');
      dynamicCheckoutRoot.classList.remove('is-loading');
      dynamicCheckoutRoot.dataset.soldOut = 'true';
    }

    var url = new URL(window.location.href);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url.toString());
  }

  function updateVariantUI(variant, options) {
    setVariantLoading(false);
    options = options || {};
    setProductCartStatus('');
    if (!variant) {
      if (window.AxiomProductBadges) {
        window.AxiomProductBadges.update(root, { productId: productData && productData.id, available: false, price: 0, compareAtPrice: 0, purchaseOptionLabel: '' });
      }
      setUnavailableSelectionUI();
      syncOptionAvailabilityUI();
      syncVariantImageSwatchesUI();
      if (window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.dispatchProductSelect === 'function') {
        window.AxiomStandardStorefront.dispatchProductSelect(sectionEl, productData, null, currentOptions);
      }
      return;
    }
    syncSelectedOptionsUI(variant);
    if (variantIdInput) variantIdInput.value = variant.id;
    var priceEl = queryInRoot('[data-price]');
    var priceBlock = queryInRoot('[data-price-block]');
    var compareEl = queryInRoot('[data-compare-price]');
    var saveEl = queryInRoot('[data-save-badge]');
    var atcBtn = queryInRoot('[data-atc-btn]');
    var stickyRoot = document.getElementById('stickyAtc') || queryById(sectionScope, 'stickyAtc');
    var stickyPrice = stickyRoot ? stickyRoot.querySelector('[data-sticky-price]') : null;
    var stickyButton = stickyRoot ? stickyRoot.querySelector('[data-sticky-atc]') : null;
    var stickyThumb = stickyRoot ? stickyRoot.querySelector('.sticky-thumb') : null;
    var skuEl = queryInRoot('[data-sku]');
    var unitPriceEl = queryInRoot('[data-unit-price]');
    var purchaseOptionState = null;
    var displayPricing = getDisplayPricing(variant, purchaseOptionState);
    var price = displayPricing.price;
    var compare = displayPricing.compareAtPrice;
    if (priceBlock) priceBlock.toggleAttribute('data-on-sale', Boolean(compare && compare > price));
    var soldOutByRule = isQuantityRuleSoldOut(variant);
    if (window.AxiomProductBadges) {
      window.AxiomProductBadges.update(root, {
        productId: productData && productData.id,
        available: variant.available,
        price: variant.price,
        compareAtPrice: variant.compare_at_price,
        purchaseOptionLabel: purchaseOptionState && purchaseOptionState.purchaseOptionLabel,
      });
    }
    if (priceEl) priceEl.classList.remove('price-current--unavailable');
    if (priceEl) {
      priceEl.textContent = money(price);
      priceEl.setAttribute('aria-label', (compare && compare > price ? priceBlock && priceBlock.dataset.salePriceLabel : priceBlock && priceBlock.dataset.regularPriceLabel) + ': ' + money(price));
    }
    var atcPriceCurrent = queryInRoot('[data-atc-price-current]');
    var atcPriceCompare = queryInRoot('[data-atc-price-compare]');
    if (atcPriceCurrent) atcPriceCurrent.textContent = money(price);
    if (atcPriceCompare) {
      if (compare && compare > price) {
        atcPriceCompare.hidden = false;
        atcPriceCompare.textContent = money(compare);
      } else {
        atcPriceCompare.hidden = true;
        atcPriceCompare.textContent = '';
      }
    }
    if (stickyPrice) stickyPrice.textContent = money(price);
    if (compare && compare > price) {
      if (compareEl) {
        compareEl.hidden = false;
        compareEl.textContent = money(compare);
        compareEl.setAttribute('aria-label', (priceBlock && priceBlock.dataset.regularPriceLabel) + ': ' + money(compare));
        compareEl.style.display = '';
      }
      if (saveEl) {
        saveEl.hidden = false;
        var savingTemplate = atcBtn ? (atcBtn.dataset.savingLabel || productString('saving')) : productString('saving');
        var savingMode = atcBtn ? (atcBtn.dataset.savingMode || 'amount') : 'amount';
        saveEl.textContent = formatSaveLabel(compare, price, savingTemplate, savingMode);
        saveEl.style.display = '';
      }
    } else {
      if (compareEl) {
        compareEl.hidden = true;
        compareEl.style.display = 'none';
      }
      if (saveEl) {
        saveEl.hidden = true;
        saveEl.style.display = 'none';
      }
    }

    if (unitPriceEl) {
      if (variant.unit_price && variant.unit_price_measurement) {
        var measurement = variant.unit_price_measurement;
        var referenceValue = measurement.reference_value && measurement.reference_value !== 1 ? measurement.reference_value : '';
        unitPriceEl.textContent = money(variant.unit_price) + ' / ' + referenceValue + measurement.reference_unit;
        unitPriceEl.setAttribute('aria-label', (priceBlock && priceBlock.dataset.unitPriceLabel) + ': ' + unitPriceEl.textContent);
        unitPriceEl.hidden = false;
      } else {
        unitPriceEl.textContent = '';
        unitPriceEl.removeAttribute('aria-label');
        unitPriceEl.hidden = true;
      }
    }

    syncProductPurchaseControls(variant, soldOutByRule, purchaseOptionState);

    if (skuEl && variant.sku) skuEl.textContent = variant.sku;

    var stickyVariant = stickyRoot ? stickyRoot.querySelector('#stickyVariant') : null;
    if (stickyVariant) stickyVariant.textContent = variant.title !== 'Default Title' ? variant.title : '';

    if (window.AxiomAddToCartAnimation) {
      var fallbackAnimationImage = atcBtn ? atcBtn.dataset.atcAnimationFallback : '';
      var animationImage = window.AxiomAddToCartAnimation.imageForVariant(variant, fallbackAnimationImage);
      window.AxiomAddToCartAnimation.setImage(atcBtn, animationImage);
      window.AxiomAddToCartAnimation.setImage(stickyButton, animationImage);
      if (stickyThumb && animationImage) {
        stickyThumb.removeAttribute('srcset');
        stickyThumb.removeAttribute('sizes');
        stickyThumb.src = animationImage;
      }
    }

    if (galleryController && typeof galleryController.setVariantMedia === 'function') {
      galleryController.setVariantMedia(variant);
    }

    if (variant.featured_media && variant.featured_media.id) {
      setMediaById(variant.featured_media.id, options);
    } else if (variant.featured_image && variant.featured_image.id) {
      setMediaById(variant.featured_image.id, options);
    }

    syncMainQtyControls(variant, true);
    updateInventoryStatusUI(variant, soldOutByRule);
    if (window.AxiomVariantForm) window.AxiomVariantForm.syncVariantDescriptions(sectionScope, variant.id);
    syncOptionAvailabilityUI();
    syncVariantImageSwatchesUI();

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    if (window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.dispatchProductSelect === 'function') {
      window.AxiomStandardStorefront.dispatchProductSelect(sectionEl, productData, variant);
    }
    if (window.AxiomSellingPlan) window.AxiomSellingPlan.syncWithin(sectionEl, variant.id);
  }

  queryAllInRoot('[data-option-position]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = parseInt(btn.dataset.optionPosition, 10);
      var val = btn.dataset.value;
      currentOptions[pos] = val;

      var btnGroup = queryAllInRoot('[data-option-position="' + pos + '"]');
      btnGroup.forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      var colorLabel = queryInRoot('[id^="colorSelected-"]');
      if (colorLabel && btn.dataset.color) colorLabel.textContent = val;
      queryAllInRoot('[data-option-selected-value="' + pos + '"]').forEach(function (label) {
        label.textContent = val;
      });

      var shouldScrollMedia = btn.hasAttribute('data-variant-media-scroll');
      if (highVariantProduct) {
        if (highVariantRequest) highVariantRequest.abort();
        highVariantRequest = new AbortController();
        var request = highVariantRequest;
        selectedHighVariant = null;
        setVariantLoading(true);
        if (window.AxiomVariantForm && typeof window.AxiomVariantForm.setVariantImageSwatchesLoading === 'function') {
          window.AxiomVariantForm.setVariantImageSwatchesLoading({
            root: sectionEl,
            buttonSelector: '[data-option-position]'
          }, true);
        }
        if (variantIdInput) variantIdInput.value = '';
        var pendingAtc = queryInRoot('[data-atc-btn]');
        if (pendingAtc) pendingAtc.disabled = true;
        var pendingSticky = document.getElementById('stickyAtc');
        var pendingStickyButton = pendingSticky && pendingSticky.querySelector('[data-sticky-atc]');
        if (pendingStickyButton) pendingStickyButton.disabled = true;
        if (dynamicCheckoutRoot) dynamicCheckoutRoot.classList.add('dynamic-checkout--disabled');
        window.AxiomHighVariantPicker.request(
          highVariantState.productUrl,
          window.AxiomHighVariantPicker.selectedOptionValueIds(sectionEl, '[data-option-position]'),
          request.signal
        ).then(function (state) {
          if (request !== highVariantRequest) return;
          highVariantRequest = null;
          highVariantState = state;
          selectedHighVariant = state.variant;
          if (state.variant && state.variantState) {
            productB2BConfig.variants = productB2BConfig.variants || {};
            productB2BConfig.variants[String(state.variant.id)] = state.variantState;
            sectionEl.dispatchEvent(new CustomEvent('product:variant-state', {
              detail: {
                productId: productData && productData.id,
                variantId: state.variant.id,
                variantState: state.variantState
              }
            }));
          }
          updateVariantUI(state.variant, {
            scrollMedia: shouldScrollMedia,
            scrollThumb: shouldScrollMedia
          });
        }).catch(function (error) {
          if (error.name === 'AbortError' || request !== highVariantRequest) return;
          highVariantRequest = null;
          if (window.AxiomVariantForm && typeof window.AxiomVariantForm.setVariantImageSwatchesLoading === 'function') {
            window.AxiomVariantForm.setVariantImageSwatchesLoading({
              root: sectionEl,
              buttonSelector: '[data-option-position]'
            }, false);
          }
          setUnavailableSelectionUI();
          setProductCartStatus(error.message || productString('unavailable'));
        });
        return;
      }
      updateVariantUI(getSelectedVariant(), {
        scrollMedia: shouldScrollMedia,
        scrollThumb: shouldScrollMedia
      });
    });
  });

  // Init current options from DOM
  queryAllInRoot('[data-option-position].active').forEach(function (btn) {
    currentOptions[parseInt(btn.dataset.optionPosition, 10)] = btn.dataset.value;
  });
  syncVariantImageSwatchesUI();

  // ── QUANTITY ──────────────────────────────────
  var qtyInput = queryInRoot('[data-qty-input]');
  var qtyVal = queryInRoot('[data-qty-val]');
  var qtyMinusBtn = queryInRoot('[data-qty-minus]');
  var qtyPlusBtn = queryInRoot('[data-qty-plus]');

  function getActiveVariantForQty() {
    if (highVariantProduct) {
      return selectedHighVariant && variantIdInput && String(selectedHighVariant.id) === String(variantIdInput.value)
        ? selectedHighVariant : null;
    }
    if (!variantIdInput || !variantIdInput.value || !productData || !productData.variants) return null;
    return productData.variants.find(function (variant) {
      return String(variant.id) === String(variantIdInput.value);
    }) || null;
  }

  function syncMainQtyControls(variant, keepCurrentValue) {
    if (!qtyInput || !qtyVal || !variant) return;
    var quantityRule = getVariantQuantityRule(variant);
    var bounds = getProductQuantityBounds(variant);
    var soldOutByRule = isQuantityRuleSoldOut(variant);
    var cartLimitReached = isCartQuantityLimitReached(variant);
    var max = bounds.max;
    var nextQty = soldOutByRule
      ? 0
      : cartLimitReached
        ? bounds.min
        : normalizeMainQty(keepCurrentValue ? qtyInput.value : quantityRule.min, variant, false);

    qtyInput.value = nextQty;
    qtyVal.textContent = nextQty;
    qtyInput.min = bounds.min;
    qtyInput.step = quantityRule.increment;
    if (max !== null && max >= bounds.min) {
      qtyInput.max = max;
    } else {
      qtyInput.removeAttribute('max');
    }

    if (qtyMinusBtn) qtyMinusBtn.disabled = soldOutByRule || cartLimitReached || nextQty <= bounds.min;
    if (qtyPlusBtn) qtyPlusBtn.disabled = soldOutByRule || cartLimitReached || (max !== null && nextQty >= max);
    if (cartLimitReached) setProductCartStatus(productString('maximumQuantityInBag'));
    dispatchQuantityChange(variant, nextQty);
  }

  if (qtyMinusBtn) {
    qtyMinusBtn.addEventListener('click', function () {
      var activeVariant = getActiveVariantForQty();
      if (!activeVariant || !qtyInput || !qtyVal) return;
      var quantityRule = getVariantQuantityRule(activeVariant);
      var currentQty = parseInt(qtyInput.value || quantityRule.min, 10) || quantityRule.min;
      var nextQty = normalizeMainQty(currentQty - quantityRule.increment, activeVariant, false);
      qtyInput.value = nextQty;
      qtyVal.textContent = nextQty;
      setProductCartStatus('');
      syncMainQtyControls(activeVariant, true);
    });
  }

  if (qtyPlusBtn) {
    qtyPlusBtn.addEventListener('click', function () {
      var activeVariant = getActiveVariantForQty();
      if (!activeVariant || !qtyInput || !qtyVal) return;
      var quantityRule = getVariantQuantityRule(activeVariant);
      var currentQty = parseInt(qtyInput.value || quantityRule.min, 10) || quantityRule.min;
      var requestedQuantity = currentQty + quantityRule.increment;
      var nextQty = normalizeMainQty(requestedQuantity, activeVariant, false);
      qtyInput.value = nextQty;
      qtyVal.textContent = nextQty;
      var effectiveMax = getEffectiveMaxQty(activeVariant);
      setProductCartStatus(effectiveMax !== null && requestedQuantity >= effectiveMax
        ? quantityLimitMessage(effectiveMax)
        : '');
      syncMainQtyControls(activeVariant, true);
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var activeVariant = getActiveVariantForQty();
      if (!activeVariant || !qtyVal) return;
      var rawQuantity = parseInt(qtyInput.value, 10);
      var nextQty = normalizeMainQty(rawQuantity, activeVariant, false);
      qtyInput.value = nextQty;
      qtyVal.textContent = nextQty;
      var effectiveMax = getEffectiveMaxQty(activeVariant);
      setProductCartStatus(effectiveMax !== null && Number.isFinite(rawQuantity) && rawQuantity >= effectiveMax
        ? quantityLimitMessage(effectiveMax)
        : '');
      syncMainQtyControls(activeVariant, true);
    });
  }

  // Liquid renders the page for the selected variant (price, buttons, quantity, options, URL).
  // Boot only re-runs the whole variant UI when the form state differs from that render, e.g. a
  // browser restored other option inputs on Back. Otherwise it only syncs the state that script
  // owns (gallery, B2B-aware option availability, purchase options), all idempotent, and leaves
  // the URL, prices, buttons and sticky bar as rendered.
  var initialVariant = getSelectedVariant();
  var renderedVariantId = variantIdInput ? String(variantIdInput.value || '') : '';
  if (initialVariant && String(initialVariant.id) === renderedVariantId) {
    if (galleryController && typeof galleryController.setVariantMedia === 'function') {
      galleryController.setVariantMedia(initialVariant);
    }
    if (initialVariant.featured_media && initialVariant.featured_media.id) {
      setMediaById(initialVariant.featured_media.id);
    } else if (initialVariant.featured_image && initialVariant.featured_image.id) {
      setMediaById(initialVariant.featured_image.id);
    }
    syncOptionAvailabilityUI();
    syncVariantImageSwatchesUI();
    if (window.AxiomSellingPlan) window.AxiomSellingPlan.syncWithin(sectionEl, initialVariant.id);
  } else if (initialVariant) {
    updateVariantUI(initialVariant);
  }

  // â”€â”€ AJAX PRODUCT FORM â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var productForm = queryInRoot('[data-product-form]');
  var giftCardRecipient = queryInRoot('[data-gift-card-recipient]');
  var giftCardRecipientToggle = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-toggle]');
  var giftCardRecipientFields = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-fields]');
  var giftCardRecipientEmail = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-email]');
  var giftCardRecipientSendOn = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-send-on]');
  var giftCardRecipientOffset = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-offset]');
  var giftCardRecipientError = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-error]');
  var giftCardRecipientStatus = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-status]');
  function setProductCartStatus(message) {
    if (!productCartStatus) return;
    var nextMessage = String(message || '').trim();
    productCartStatus.textContent = '';
    productCartStatus.hidden = !nextMessage;
    if (!nextMessage) return;
    window.requestAnimationFrame(function () {
      if (productCartStatus && productCartStatus.isConnected) productCartStatus.textContent = nextMessage;
    });
  }

  function quantityLimitMessage(count) {
    var cartApi = window.AxiomStandardStorefront;
    return cartApi && typeof cartApi.quantityLimitMessage === 'function'
      ? cartApi.quantityLimitMessage(count)
      : 'You can only add ' + Math.max(0, parseInt(count, 10) || 0) + ' of this item to your bag.';
  }

  function productInventoryWarning(message, result, variant, requestedQuantity) {
    var cartApi = window.AxiomStandardStorefront;
    if (!cartApi || typeof cartApi.getCartLines !== 'function' || !result || !result.cart || !variant) return message;
    var variantId = String(variant.id);
    var resultQuantity = cartApi.getCartLines(result.cart).reduce(function (total, line) {
      var merchandiseId = line && line.merchandise && line.merchandise.id || line && line.merchandiseId || '';
      return String(merchandiseId).split('/').pop() === variantId
        ? total + (parseInt(line.quantity, 10) || 0)
        : total;
    }, 0);
    var allowedQuantity = Math.max(0, resultQuantity - getVariantCartQuantity(variant));
    return allowedQuantity < requestedQuantity ? quantityLimitMessage(allowedQuantity) : message;
  }

  function syncProductCartQuantity(result, variant) {
    var variantState = variant && getVariantB2BData(variant.id);
    var cartApi = window.AxiomStandardStorefront;
    if (!variantState || !result || !result.cart || !cartApi || typeof cartApi.getCartLines !== 'function') return;
    var variantId = String(variant.id);
    variantState.cartQuantity = cartApi.getCartLines(result.cart).reduce(function (total, line) {
      var merchandiseId = line && line.merchandise && line.merchandise.id || line && line.merchandiseId || '';
      if (String(merchandiseId).split('/').pop() !== variantId) return total;
      return total + (parseInt(line.quantity, 10) || 0);
    }, 0);
  }

  function syncProductCartState(result) {
    var activeVariant = getActiveVariantForQty() || getSelectedVariant();
    if (!activeVariant || !result || !result.cart) return;
    setProductCartStatus('');
    syncProductCartQuantity(result, activeVariant);
    var purchaseOptionState = null;
    syncProductPurchaseControls(activeVariant, isQuantityRuleSoldOut(activeVariant), purchaseOptionState);
    syncMainQtyControls(activeVariant, false);
    updateInventoryStatusUI(activeVariant, isQuantityRuleSoldOut(activeVariant));
  }

  on(document, 'shopify:cart:lines-update', function (event) {
    if (!event || !event.promise) return;
    var eventDetail = event.detail || {};
    var source = eventDetail.source || eventDetail.detail && eventDetail.detail.source || '';
    if (source === 'product') return;
    event.promise.then(function (result) {
      if (result && Array.isArray(result.userErrors) && result.userErrors.length) return;
      syncProductCartState(result);
    }).catch(function () {});
  });

  function formatRecipientDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function syncGiftCardRecipient() {
    if (!giftCardRecipientToggle || !giftCardRecipientFields) return;
    var enabled = giftCardRecipientToggle.checked;
    giftCardRecipientToggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');
    giftCardRecipientFields.hidden = !enabled;
    giftCardRecipientFields.querySelectorAll('input, textarea').forEach(function (field) {
      field.disabled = !enabled;
      if (!enabled) field.value = '';
    });
    if (giftCardRecipientEmail) giftCardRecipientEmail.required = enabled;
    if (giftCardRecipientEmail) giftCardRecipientEmail.removeAttribute('aria-invalid');
    if (giftCardRecipientSendOn) giftCardRecipientSendOn.removeAttribute('aria-invalid');
    if (giftCardRecipientOffset && enabled) giftCardRecipientOffset.value = String(new Date().getTimezoneOffset());
    if (giftCardRecipientError) giftCardRecipientError.hidden = true;
  }

  function validateGiftCardRecipient(event) {
    if (!giftCardRecipientToggle || !giftCardRecipientToggle.checked || !giftCardRecipientEmail) return;
    if (giftCardRecipientEmail.checkValidity() && (!giftCardRecipientSendOn || giftCardRecipientSendOn.checkValidity())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (giftCardRecipientError) giftCardRecipientError.hidden = false;
    if (giftCardRecipientStatus && giftCardRecipientError) giftCardRecipientStatus.textContent = giftCardRecipientError.textContent;
    var invalidField = giftCardRecipientEmail.checkValidity() ? giftCardRecipientSendOn : giftCardRecipientEmail;
    if (giftCardRecipientEmail) giftCardRecipientEmail.setAttribute('aria-invalid', giftCardRecipientEmail.checkValidity() ? 'false' : 'true');
    if (giftCardRecipientSendOn) giftCardRecipientSendOn.setAttribute('aria-invalid', giftCardRecipientSendOn.checkValidity() ? 'false' : 'true');
    if (invalidField && typeof invalidField.reportValidity === 'function') invalidField.reportValidity();
  }

  if (giftCardRecipientToggle) {
    var recipientToday = new Date();
    var recipientMaxDate = new Date(recipientToday.getFullYear(), recipientToday.getMonth(), recipientToday.getDate() + 90);
    if (giftCardRecipientSendOn) {
      giftCardRecipientSendOn.min = formatRecipientDate(recipientToday);
      giftCardRecipientSendOn.max = formatRecipientDate(recipientMaxDate);
    }
    giftCardRecipientToggle.addEventListener('change', syncGiftCardRecipient);
    syncGiftCardRecipient();
  }
  function showAtcAddedFeedback(result) {
    if (!atcBtn) return;
    var activeVariant = getActiveVariantForQty() || getSelectedVariant();
    if (activeVariant) {
      syncProductCartQuantity(result, activeVariant);
      var purchaseOptionState = null;
      syncProductPurchaseControls(activeVariant, isQuantityRuleSoldOut(activeVariant), purchaseOptionState);
      syncMainQtyControls(activeVariant, false);
      updateInventoryStatusUI(activeVariant, isQuantityRuleSoldOut(activeVariant));
    }
    atcBtn.classList.remove('loading');
    if (window.AxiomAddToCartAnimation && window.AxiomAddToCartAnimation.isEnabled()) {
      atcBtn.classList.remove('added');
      var activeLabel = atcBtn.querySelector('.atc-label');
      if (activeLabel && activeVariant) setMotionButtonText(activeLabel, getAtcActiveLabel(atcBtn));
      if (atcFeedbackTimer) {
        window.clearTimeout(atcFeedbackTimer);
        atcFeedbackTimer = null;
      }
      if (giftCardRecipientStatus && giftCardRecipientToggle && giftCardRecipientToggle.checked) {
        giftCardRecipientStatus.textContent = atcBtn.dataset.addedLabel || productString('added');
        giftCardRecipientToggle.checked = false;
        syncGiftCardRecipient();
      }
      return;
    }
    atcBtn.classList.add('added');
    var label = atcBtn.querySelector('.atc-label');
    setMotionButtonText(label, atcBtn.dataset.addedLabel || productString('added'));
    if (giftCardRecipientStatus && giftCardRecipientToggle && giftCardRecipientToggle.checked) {
      giftCardRecipientStatus.textContent = atcBtn.dataset.addedLabel || productString('added');
      giftCardRecipientToggle.checked = false;
      syncGiftCardRecipient();
    }
    if (atcFeedbackTimer) {
      window.clearTimeout(atcFeedbackTimer);
    }
    atcFeedbackTimer = window.setTimeout(function () {
      atcBtn.classList.remove('added');
      var currentVariant = getActiveVariantForQty();
      if (label && currentVariant) setMotionButtonText(label, getAtcActiveLabel(atcBtn));
    }, 2000);
  }

  if (productForm) {
    productForm.addEventListener('submit', validateGiftCardRecipient, true);
    productForm.addEventListener('submit', function (event) {
      var customOptionValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
        ? window.AxiomCustomOptions.validate(productForm)
        : { valid: true };
      if (!customOptionValidation.valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setProductCartStatus(customOptionValidation.message);
        return;
      }
      var submitter = getFormSubmitter(event);
      if (!submitter || !submitter.matches('[data-atc-btn]')) {
        if (window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(productForm)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setDynamicCheckoutLoading(true);
          window.AxiomStandardStorefront.addProductForm(productForm, {
            target: productForm,
            source: 'product',
            redirectToCheckout: true
          }).catch(function (error) {
            setDynamicCheckoutLoading(false);
            setProductCartStatus(error && error.message || cartString('addError'));
          });
          return;
        }
        var checkoutVariant = getActiveVariantForQty() || getSelectedVariant();
        var checkoutPlanValidation = window.AxiomSellingPlan && checkoutVariant
          ? window.AxiomSellingPlan.validateVariant(productForm, getVariantB2BData(checkoutVariant.id) || checkoutVariant)
          : { valid: true };
        if (!checkoutPlanValidation.valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!checkoutPlanValidation.displayed) setProductCartStatus(checkoutPlanValidation.message);
          return;
        }
        if (dynamicCheckoutRoot && dynamicCheckoutRoot.classList.contains('dynamic-checkout--disabled')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        setDynamicCheckoutLoading(true);
        return;
      }
      event.preventDefault();
      if (!variantIdInput || !variantIdInput.value) return;
      if (atcBtn && atcBtn.disabled) return;
      var activeVariant = getActiveVariantForQty() || getSelectedVariant();
      var planValidation = window.AxiomSellingPlan && activeVariant
        ? window.AxiomSellingPlan.validateVariant(productForm, getVariantB2BData(activeVariant.id) || activeVariant)
        : { valid: true };
      if (!planValidation.valid) {
        if (!planValidation.displayed) setProductCartStatus(planValidation.message);
        return;
      }
      setProductCartStatus('');
      if (window.AxiomAddToCartAnimation) {
        var animationContext = atcBtn && atcBtn._axiomAnimationContext;
        if (atcBtn) delete atcBtn._axiomAnimationContext;
        window.AxiomAddToCartAnimation.play({
          button: animationContext && animationContext.button || atcBtn,
          source: animationContext && animationContext.source,
          imageUrl: animationContext && animationContext.imageUrl || window.AxiomAddToCartAnimation.imageForVariant(activeVariant, atcBtn && atcBtn.dataset.atcAnimationFallback),
          mode: animationContext && animationContext.mode || 'main'
        });
      }
      if (atcBtn) atcBtn.classList.add('loading');
      var customOptionValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
        ? window.AxiomCustomOptions.validate(productForm)
        : { valid: true };
      if (!customOptionValidation.valid) {
        setProductCartStatus(customOptionValidation.message);
        if (atcBtn) atcBtn.classList.remove('loading');
        return;
      }
      var addRequest = window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(productForm)
        ? window.AxiomStandardStorefront.addProductForm(productForm, { target: productForm, source: 'product' })
        : window.AxiomStandardStorefront.addLines({
            id: parseInt(variantIdInput.value, 10),
            quantity: qtyInput ? parseInt(qtyInput.value || '1', 10) : 1,
            properties: window.AxiomVariantForm.collectProperties(productForm),
            sellingPlanId: sellingPlanIdFromForm(productForm)
          }, {
            target: productForm,
            source: 'product',
            onWarning: function (message, result) {
              var requestedQuantity = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
              setProductCartStatus(productInventoryWarning(message, result, activeVariant, requestedQuantity));
            }
          });
      addRequest.then(function (result) {
        // A Gift wrap block adds the wrap for the line just added.
        if (window.AxiomGiftWrap) window.AxiomGiftWrap.afterAdd(productForm, result);
        return showAtcAddedFeedback(result);
      }).catch(function (error) {
        var effectiveMax = activeVariant && getEffectiveMaxQty(activeVariant);
        setProductCartStatus(error && error.code === 'MAXIMUM_EXCEEDED' && effectiveMax !== null
          ? quantityLimitMessage(effectiveMax)
          : error && error.message || cartString('addError'));
        if (atcBtn) atcBtn.classList.remove('loading');
      });
    });
  }
  if (dynamicCheckoutRoot) {
    on(dynamicCheckoutRoot, 'click', function (event) {
      if (!isDynamicCheckoutActivation(event)) return;

      if (window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(productForm)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var fileCheckoutValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
          ? window.AxiomCustomOptions.validate(productForm)
          : { valid: true };
        if (!fileCheckoutValidation.valid) {
          setProductCartStatus(fileCheckoutValidation.message);
          return;
        }
        setDynamicCheckoutLoading(true);
        window.AxiomStandardStorefront.addProductForm(productForm, {
          target: productForm,
          source: 'product',
          redirectToCheckout: true
        }).catch(function (error) {
          setDynamicCheckoutLoading(false);
          setProductCartStatus(error && error.message || cartString('addError'));
        });
        return;
      }

      if (dynamicCheckoutRoot.classList.contains('dynamic-checkout--disabled')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var activeVariant = getActiveVariantForQty() || getSelectedVariant();
        return;
      }
      setDynamicCheckoutLoading(true);
    }, true);
    on(window, 'pageshow', function () {
      setDynamicCheckoutLoading(false);
    });
  }

  // ── ATC FEEDBACK ──────────────────────────────
  var atcBtn = queryInRoot('[data-atc-btn]');
  if (atcBtn) {
    on(document, 'shopify:cart:error', function () {
      atcBtn.classList.remove('loading');
      if (giftCardRecipientToggle && giftCardRecipientToggle.checked && giftCardRecipientError) {
        giftCardRecipientError.hidden = false;
        if (giftCardRecipientStatus) giftCardRecipientStatus.textContent = giftCardRecipientError.textContent;
      }
    });
  }

  // ── STICKY ATC ────────────────────────────────
  var stickyAtc = queryById(sectionScope, 'stickyAtc');
  var anchor = queryById(sectionEl, 'productFormAnchor');
  var secondDetailsContainer = sectionEl.querySelector('[data-product-container="second"]');
  var mediaGallery = queryInRoot('[data-media-gallery]');
  portalStickyAtc(stickyAtc);
  function setScrollToTopOffset(offset) {
    // Set on the button that uses it: changing an inherited property on <html>
    // restyles the whole page, a long frame each time the sticky bar toggles.
    var value = Math.max(0, offset || 0) + 'px';
    document.querySelectorAll('.scroll-to-top').forEach(function (button) {
      button.style.setProperty('--scroll-to-top-sticky-offset', value);
    });
  }
  function updateScrollToTopOffset() {
    if (!stickyAtc || !stickyAtc.classList.contains('visible')) {
      setScrollToTopOffset(0);
      return;
    }
    var rect = stickyAtc.getBoundingClientRect();
    setScrollToTopOffset(rect.height + 16);
  }
  if (stickyAtc && anchor) {
    function updateStickyAtcVisibility() {
      var viewportHeight = document.documentElement.clientHeight;
      var anchorRect = anchor.getBoundingClientRect();
      var detailsTop = anchorRect.top;
      var detailsBottom = anchorRect.bottom;
      if (secondDetailsContainer) {
        var secondRect = secondDetailsContainer.getBoundingClientRect();
        detailsTop = Math.min(detailsTop, secondRect.top);
        detailsBottom = Math.max(detailsBottom, secondRect.bottom);
      }
      var show = detailsBottom <= 0 || detailsTop >= viewportHeight;

      if (window.matchMedia('(max-width: 767px)').matches && stickyAtc.dataset.mobileStickyAtcOnTop !== 'true') {
        var mediaPassed = mediaGallery
          ? mediaGallery.getBoundingClientRect().bottom <= 0
          : atcBtn && atcBtn.getBoundingClientRect().bottom <= 0;
        var buttonRect = atcBtn && atcBtn.getBoundingClientRect();
        var buttonVisible = buttonRect && buttonRect.bottom > 0 && buttonRect.top < viewportHeight;
        show = Boolean(mediaPassed && !buttonVisible);
      }

      stickyAtc.classList.toggle('visible', show);
      stickyAtc.setAttribute('aria-hidden', String(!show));
      stickyAtc.toggleAttribute('inert', !show);
      updateScrollToTopOffset();
    }
    stickyObs = new IntersectionObserver(function () {
      updateStickyAtcVisibility();
    }, { threshold: 0 });
    stickyObs.observe(anchor);
    if (secondDetailsContainer) stickyObs.observe(secondDetailsContainer);
    if (mediaGallery) stickyObs.observe(mediaGallery);
    if (atcBtn) stickyObs.observe(atcBtn);
    if (typeof ResizeObserver !== 'undefined') {
      stickyResizeObserver = new ResizeObserver(function () {
        updateScrollToTopOffset();
      });
      stickyResizeObserver.observe(stickyAtc);
    }
    on(window, 'resize', updateStickyAtcVisibility);
    updateStickyAtcVisibility();
  } else {
    setScrollToTopOffset(0);
  }
  var stickyBtn = stickyAtc ? stickyAtc.querySelector('[data-sticky-atc]') : null;
  if (stickyBtn && atcBtn) {
    stickyBtn.addEventListener('click', function () {
      var stickyThumb = stickyAtc.querySelector('.sticky-thumb');
      atcBtn._axiomAnimationContext = {
        button: stickyBtn,
        source: stickyThumb || stickyBtn,
        imageUrl: stickyBtn.dataset.atcAnimationImage || '',
        mode: 'sticky'
      };
      atcBtn.click();
      delete atcBtn._axiomAnimationContext;
    });
  }

  // ── SHARE ─────────────────────────────────────
  var shareBtn = queryInRoot('[data-share-btn]');
  if (shareBtn && window.Axiom && window.Axiom.initShareButtons) {
    window.Axiom.initShareButtons();
  }

  sectionEl.__productCleanup = function () {
    if (highVariantRequest) highVariantRequest.abort();
    pauseProductMedia();
    if (galleryController) {
      galleryController.dispose();
    }
    cleanups.forEach(function (cleanup) {
      cleanup();
    });
    cleanups = [];

    if (stickyObs) {
      stickyObs.disconnect();
      stickyObs = null;
    }

    if (stickyResizeObserver) {
      stickyResizeObserver.disconnect();
      stickyResizeObserver = null;
    }

    if (stickyAtc && stickyAtc.parentNode === document.body) {
      stickyAtc.remove();
    }

    if (atcFeedbackTimer) {
      window.clearTimeout(atcFeedbackTimer);
      atcFeedbackTimer = null;
    }

    setScrollToTopOffset(0);

    if (sectionEl.dataset) {
      sectionEl.dataset.productInitialized = 'false';
    }
    sectionEl.__productCleanup = null;
  };
  }

  initAxiomProduct(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAxiomProduct(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-product-root]').forEach(function (sectionEl) {
      if (typeof sectionEl.__productCleanup === 'function') {
        sectionEl.__productCleanup();
      }
    });
  });
})();

